import { takeEvery, put, call, select } from 'redux-saga/effects';
import { listOrders, listLimitOrders, getMarketData, deleteLimitOrder } from '../../services/allApiService';
import {
  fetchLimitOrdersRequest,
  fetchOrdersSuccess,
  fetchOrdersFailure,
  deleteLimitOrderRequest,
  deleteLimitOrderSuccess,
  deleteLimitOrderFailure,
  fetchLimitOrdersSuccess,
  fetchLimitOrdersFailure,
  fetchMarketDataSuccess,
  fetchMarketDataFailure,
} from '../reducers/orderReducer';

function* fetchOrdersSaga() {
  try {
    const response = yield call(listOrders);
    const data = response?.data?.records;
    yield put(fetchOrdersSuccess(Array.isArray(data) ? data : []));
  } catch (error) {
    yield put(fetchOrdersFailure('Failed to fetch orders'));
  }
}

function* fetchLimitOrdersSaga() {
  try {
    const response = yield call(listLimitOrders);
    const data = response?.data;
    yield put(fetchLimitOrdersSuccess(Array.isArray(data) ? data : []));
  } catch (error) {
    yield put(fetchLimitOrdersFailure('Failed to fetch limit orders'));
  }
}

function* fetchMarketDataSaga({ payload: orders }) {
  try {
    // const filteredOrders = orders.filter(order => order.square_off === '0');

    // if (filteredOrders.length === 0) return;

    // ── ONE-TIME snapshot for last prices (works even when the market is
    // closed). useMarketData only polls while the socket is down, so this fires
    // once on load; the socket then keeps the order cards live.
    const exchangeTokens = {};
    orders.forEach(order => {
      let exchange = order.exchange;
      if (exchange === "EQUITY" || exchange === "EQUITY(INDEX)") exchange = "NFO";
      if (!exchangeTokens[exchange]) exchangeTokens[exchange] = [];
      if (!exchangeTokens[exchange].includes(order.token)) {
        exchangeTokens[exchange].push(order.token);
      }
    });

    const mode = "FULL";
    const response = yield call(getMarketData, mode, exchangeTokens);
    const fetchedData = response.data.fetched;

    const updatedOrdersWithDifferences = orders.map(order => {

      const marketData = fetchedData.find(data => String(data.symbolToken) === String(order.token));

      if (marketData && marketData.depth) {
        let bestMarketPrice = null;
        let priceDifference = null;
        if (order.type === 'buy' && marketData.depth.buy?.[0]) {

          bestMarketPrice = marketData.depth.buy[0].price;
          priceDifference = bestMarketPrice - order.price;

        } else if (order.type === 'sell' && marketData.depth.sell?.[0]) {

          bestMarketPrice = marketData.depth.sell[0].price;
          priceDifference = order.price - bestMarketPrice;

        }
        return { ...order, marketData, priceDifference };
      }
      return { ...order, marketData: null, priceDifference: null };
    });

    yield put(fetchMarketDataSuccess(updatedOrdersWithDifferences));
  } catch (error) {
    yield put(fetchMarketDataFailure('Failed to fetch market data'));
  }
}

function* handleDeleteLimitOrderlist(action) {
  try {
    const limitOrderId = action.payload?.itemToDelete?.limit_order_id;

    // const activeTab = yield select(state => state.watchlist.activeTab);

    const response = yield call(deleteLimitOrder, limitOrderId);

    if (response.success) {
      // yield put(deleteLimitOrderSuccess({ limitOrderId }));

      // Refresh the watchlist data
      yield put(fetchLimitOrdersRequest());
    } else {
      yield put(deleteLimitOrderFailure(response.message || 'Failed to delete from watchlist'));
    }
  } catch (error) {
    yield put(deleteLimitOrderFailure(error.message));
  }
}


export default function* orderRootSaga() {
  yield takeEvery('orders/fetchOrdersRequest', fetchOrdersSaga);
  yield takeEvery('orders/fetchLimitOrdersRequest', fetchLimitOrdersSaga);
  yield takeEvery('orders/fetchMarketDataRequest', fetchMarketDataSaga);
  yield takeEvery(deleteLimitOrderRequest.type, handleDeleteLimitOrderlist);

}